export const GET_AUDIT_LOOKUPS_REQUEST = "GET_AUDIT_LOOKUPS_REQUEST";
export const GET_AUDIT_LOOKUPS_SUCCESS = "GET_AUDIT_LOOKUPS_SUCCESS";
export const GET_AUDIT_LOOKUPS_FAIL = "GET_AUDIT_LOOKUPS_FAIL";

export const GET_AUDIT_QUALITY_SUMMARY_DATA_REQUEST = "GET_AUDIT_QUALITY_SUMMARY_DATA_REQUEST";
export const GET_AUDIT_QUALITY_SUMMARY_DATA_SUCCESS = "GET_AUDIT_QUALITY_SUMMARY_DATA_SUCCESS";
export const GET_AUDIT_QUALITY_SUMMARY_DATA_FAIL = "GET_AUDIT_QUALITY_SUMMARY_DATA_FAIL";

export const GET_UNASSIGNED_INCIDENTS_REQUEST = "GET_UNASSIGNED_INCIDENTS_REQUEST";
export const GET_UNASSIGNED_INCIDENTS_SUCCESS = "GET_UNASSIGNED_INCIDENTS_SUCCESS";
export const GET_UNASSIGNED_INCIDENTS_FAIL = "GET_UNASSIGNED_INCIDENTS_FAIL";

export const GET_ALL_INCIDENTS_REQUEST = "GET_ALL_INCIDENTS_REQUEST";
export const GET_ALL_INCIDENTS_SUCCESS = "GET_ALL_INCIDENTS_SUCCESS";
export const GET_ALL_INCIDENTS_FAIL = "GET_ALL_INCIDENTS_FAIL";

export const GET_PENDING_AUDITS_REQUEST = "GET_PENDING_AUDITS_REQUEST";
export const GET_PENDING_AUDITS_SUCCESS = "GET_PENDING_AUDITS_SUCCESS";
export const GET_PENDING_AUDITS_FAIL = "GET_PENDING_AUDITS_FAIL";

export const GET_PENDING_REVIEW_REQUEST = "GET_PENDING_REVIEW_REQUEST";
export const GET_PENDING_REVIEW_SUCCESS = "GET_PENDING_REVIEW_SUCCESS";
export const GET_PENDING_REVIEW_FAIL = "GET_PENDING_REVIEW_FAIL";

export const GET_AUDIT_DETAILS_REQUEST = "GET_AUDIT_DETAILS_REQUEST";
export const GET_AUDIT_DETAILS_SUCCESS = "GET_AUDIT_DETAILS_SUCCESS";
export const GET_AUDIT_DETAILS_FAIL = "GET_AUDIT_DETAILS_FAIL";
